import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, getDoc, where } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseSoulmateService {
  async getAllSoulmates() {
    const ref = collection(db, 'soulmates')
    const q = query(ref, orderBy('createdAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getSoulmateById(id) {
    const ref = doc(db, 'soulmates', id)
    const snap = await getDoc(ref)
    if (snap.exists()) return { id: snap.id, ...snap.data() }
    return null
  }

  async getSoulmatesByUserId(userId) {
    const ref = collection(db, 'soulmates')
    const q = query(ref, where('userId', '==', userId), orderBy('createdAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }
}
